// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"4519":"f5c853dc17a4dc0c","7610":"c0aadc690c4ec6f1"}[chunkId] + ".css";
};